import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertMetadata, AlertsState, AlertModelBase, AlertKind } from '../../models';
import { v4 } from 'uuid';

@Injectable()
export class AlertStoreService {
  private currentAlertsState$ = new BehaviorSubject<AlertsState>({});

  readonly alertsState$: Observable<AlertsState> = this.currentAlertsState$.asObservable();

  getSortedAlerts(): Observable<AlertMetadata[]> {
    return this.currentAlertsState$.pipe(
      map((alertsState) => {
        return Object.values(alertsState);
      }),
      map((allertsMetadata) => {
        return allertsMetadata.sort((first, second) => Number(first.date) - Number(second.date));
      })
    );
  }

  addAlert(alertModelBase: AlertModelBase, alertKind: AlertKind): void {
    const currentState: AlertsState = this.currentAlertsState$.value;
    const alertMetadata: AlertMetadata = {
      alert: alertModelBase,
      id: alertModelBase.id || v4(),
      date: new Date(),
      alertKind,
    };
    const newState: AlertsState = {
      ...currentState,
      [alertMetadata.id]: alertMetadata,
    };

    this.currentAlertsState$.next(newState);
  }

  removeAlertAction(alertId: string): void {
    const currentState: AlertsState = this.currentAlertsState$.value;
    const newState: AlertsState = {
      ...currentState,
    };
    delete newState[alertId];
    this.currentAlertsState$.next(newState);
  }

  removeAlertByTimeoutAction(alertId: string, timeoutMs: number): void {
    setTimeout(() => {
      this.removeAlertAction(alertId);
    }, timeoutMs);
  }

  removeAll(): void {
    this.currentAlertsState$.next({});
  }
}
